import axios from 'axios';
import {encrypt} from './aes_ecb';

// 创建一个 axios 实例
const service = axios.create({
    baseURL: '/employ', // 所有的请求地址前缀部分
    timeout: 600000, // 请求超时时间毫秒
    withCredentials: true, // 异步请求携带cookie
})

//添加一个请求拦截器
let token = '';
service.interceptors.request.use(function (config) {
    let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    if (userInfo != null) {
        let openid = userInfo['openid'];
        let timestamp = Date.now();
        let tokenJson = {};
        tokenJson['openid'] = openid;
        tokenJson['timestamp'] = timestamp;
        token = encrypt(JSON.stringify(tokenJson));
    }
    config.headers['token']  = token;
    return config;
}, function (error) {
    console.error("error: " + error);
    window.localStorage.clear();
    return Promise.reject(error);
});

export const authorize = obj => service.get('/weixin/authorize', obj).then(res => res.data);//跳转网页
export const wxLogin = obj => service.post('/weixin/login', obj).then(res => res.data);//登录

export const getCityOption = obj => service.post('/option/getCityOption', obj).then(res => res.data);//城市选项
export const getTypeOption = obj => service.post('/option/getTypeOption', obj).then(res => res.data);//职能选项
export const getAllTypeOption = obj => service.post('/option/getAllTypeOption', obj).then(res => res.data);//职能选项
export const getSchoolOption = obj => service.post('/option/getSchoolOption', obj).then(res => res.data);//学校选项
export const getCompanyJobOption = obj => service.post('/option/getCompanyJobOption', obj).then(res => res.data);//公司及职位选项
export const getCompanyOption = obj => service.post('/option/getCompanyOption', obj).then(res => res.data);//公司选项
export const getAllCompanyOption = obj => service.post('/option/getAllCompanyOption', obj).then(res => res.data);//公司选项
export const getCityOptionForCompany = obj => service.post('/option/getCityOptionForCompany', obj).then(res => res.data);//公司分布的城市选项
export const getBenefitOption = obj => service.post('/option/getBenefitOption', obj).then(res => res.data);//福利待遇选项
export const getUserJobOption = obj => service.post('/option/getUserJobOption', obj).then(res => res.data);//用户意向职位选项

export const getJobList = obj => service.post('/job/getJobList', obj).then(res => res.data);//职位列表
export const uploadJob = obj => service.post('/job/upload', obj).then(res => res.data);// 上传职位
export const downloadJobTemplate = obj => service.post('/job/download', obj).then(res => res.data);// 下载模板
export const getJobManageList = obj => service.post('/job/getJobManageList', obj).then(res => res.data);//职位列表
export const postJob = obj => service.post('/job/post', obj).then(res => res.data);//发布职位
export const deleteJob = obj => service.post('/job/delete', obj).then(res => res.data);//删除职位
export const closeJob = obj => service.post('/job/close', obj).then(res => res.data);//下架职位
export const addJob = obj => service.post('/job/add', obj).then(res => res.data);// 新增职位或修改职位

export const addResume = obj => service.post('/resume/add', obj).then(res => res.data);// 用户简历新增
export const isSubmitAble = obj => service.post('/resume/isSubmitAble', obj).then(res => res.data);//用户是否可以投递简历
export const submitResume = obj => service.post('/resume/submit', obj).then(res => res.data);//用户投递简历
export const getResumeListByUser = obj => service.post('/resume/getListByUser', obj).then(res => res.data);//用户已投递列表

export const getUserList = obj => service.post('/user/getList', obj).then(res => res.data);// 用户简历列表
export const getUser = resumeId => service.get('/user/getOne/' + resumeId).then(res => res.data);// 用户简历
export const getUserJob = userId => service.get('/user/getUserJob/' + userId).then(res => res.data);// 用户简历
export const receiveResume = obj => service.post('/user/receiveResume', obj).then(res => res.data);// 接收简历
export const interview = obj => service.post('/user/interview', obj).then(res => res.data);// 邀请面试
export const isInterview = obj => service.post('/user/isInterview', obj).then(res => res.data);// 是否邀请了面试
export const feedbackInterview = obj => service.post('/user/feedbackInterview', obj).then(res => res.data);// 反馈面试结果
export const getUserPassList = obj => service.post('/user/getPassList', obj).then(res => res.data);// 用户简历列表
export const getUserAcceptList = obj => service.post('/user/getAcceptList', obj).then(res => res.data);// 用户简历列表

export const getConfigList = obj => service.post('/manager/getConfigList', obj).then(res => res.data);//配置项列表
export const editConfig = obj => service.post('/manager/editConfig', obj).then(res => res.data);// 修改配置项
export const getPeopleList = obj => service.post('/manager/getPeopleList', obj).then(res => res.data);// 登录系统人员列表
export const setManager = obj => service.post('/manager/set', obj).then(res => res.data);// 设置管理员
export const cancelManager = obj => service.post('/manager/cancel', obj).then(res => res.data);// 取消管理员

export const hitJob = obj => service.post('/hits/readJob', obj).then(res => res.data);// 添加职位点击量
export const getJobHits = jobId => service.get('/hits/countReadJob/' + jobId).then(res => res.data);// 统计职位点击量
export const hitResume = obj => service.post('/hits/readResume', obj).then(res => res.data);// 添加简历点击量
export const getResumeHits = resumeId => service.get('/hits/countReadResume/' + resumeId).then(res => res.data);// 统计职位点击量

export const downloadResume = userId => service.get('/download/resume/' + userId).then(response => response);// 下载简历
export const downloadResumeList = userIds => service.get('/download/resumeList/' + userIds).then(response => response);// 下载简历
export const downloadFile = obj => service.get('/download/file' + obj).then(response => response);// 下载附件

export const getEmployProgress = obj => service.post('/data/getEmployProgress', obj).then(res => res.data);//招聘进度
export const getPassList = obj => service.post('/data/getPassList', obj).then(res => res.data);//面试通过人员来源
export const getReadJob = obj => service.post('/data/getReadJob', obj).then(res => res.data);//浏览量明细